import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

export default function CommissionChart({ commissionData }) {
  const [isCompact, setIsCompact] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= 640 : false
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const mediaQuery = window.matchMedia("(max-width: 640px)");
    const updateCompact = (event) => setIsCompact(event.matches);

    setIsCompact(mediaQuery.matches);
    mediaQuery.addEventListener("change", updateCompact);

    return () => mediaQuery.removeEventListener("change", updateCompact);
  }, []);

  return (
    <div className="commission-chart">
      <h2 className="chart-title">Monthly Commission Overview</h2>
      <ResponsiveContainer width="100%" height={isCompact ? 220 : 300}>
        <BarChart
          data={commissionData}
          margin={{
            top: 20,
            right: isCompact ? 8 : 20,
            left: 0,
            bottom: isCompact ? 28 : 50,
          }}
          barGap={1}
          barCategoryGap={isCompact ? "10%" : "2%"}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="month"
            interval={0}
            height={isCompact ? 36 : 50}
            tick={({ x, y, payload }) => {
              const shortMonth = payload.value.split(" ")[0];
              return (
                <text
                  x={x}
                  y={y + (isCompact ? 8 : 10)}
                  textAnchor="end"
                  fontSize={isCompact ? 10 : 11}
                  fill="#666"
                  transform={`rotate(${isCompact ? -28 : -35}, ${x}, ${y + (isCompact ? 8 : 10)})`}
                >
                  {shortMonth}
                </text>
              );
            }}
          />

          <YAxis
            tickFormatter={(v) => `R${v.toLocaleString("en-ZA")}`}
            width={isCompact ? 62 : 90}
          />
          <Tooltip formatter={(value) => `R${value.toLocaleString("en-ZA")}`} />
          <Bar
            dataKey="amount"
            fill="#115159"
            radius={[1, 1, 0, 0]}
            barSize={isCompact ? 10 : 14}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
